import React from "react";

function Logo() {
  return (
    <div className="w-full h-[8vh] sm:h-[18vh] flex justify-center items-center">
      <img
        src="/logo.webp"
        alt="Logo"
        className="w-auto h-full object-contain border border-2 border-yellow-500 rounded-full"
      />
    </div>
  );
}

export default Logo;